import menu from './menu'
import meta from './meta'
import footer from './footer'

const data = {
  menu,
  meta,
  components: [
    {
      name: 'Wrapper',
      components: [
        {
          name: 'Breadcrumb',
          props: {
            urls: [],
          }
        },
        {
          name: 'Speaker',
          props: {
            name: 'Nandu Jubany',
            slug: 'nandu-jubany',
            position: 6,
            company: 'Can jubany',
            url: 'https://www.canjubany.com',
            image: '/speakers/2025/nandu-jubany.jpeg',
            text: {
              es: `
              <p>Nandu Jubany estará en formentera20 y compartirá su experiencia y   
              cómo ha construido una marca a través de la pasión, el riesgo y la   
              creatividad.  
              La identidad de marca de Nandu Jubany se caracteriza por la   
              autenticidad, la pasión y la energía que transmite tanto en su cocina   
              como en sus proyectos. Su sello distintivo es su personalidad, que une   
              sus restaurantes y otros proyectos en un único universo culinario.  
              Nandu Jubany es el centro creativo de su marca, y su personalidad,   
              intensidad y pasión son sus señas de identidad.  
              Sus restaurantes, hoteles, catering y otros productos conforman un   
              ecosistema gastronómico a su alrededor.  
              La marca Nandu Jubany se define por la pasión, la autenticidad y la   
              conexión con la tierra, elementos que se transmiten a través de su   
              imagen y estilo culinario.  
              En Formentera20, explicará el secreto de su éxito.</p>
              `,
              ca: `
              <p>Nandu Jubany cuiner, estarà a Formentera20 i compartirà la seva   
              experiència i com ha construït una marca a través de la passió, el risc i la   
              creativitat.  
              La identitat de marca de Nandu Jubany es caracteritza per l'autenticitat, la   
              passió i l'energia que transmet tant a la cuina com als projectes. El seu   
              segell distintiu és la seva personalitat, que uneix els restaurants i altres   
              projectes en un únic univers culinari.  
              Nandu Jubany és el centre creatiu de la seva marca, i la seva personalitat,   
              intensitat i passió en són les senyes d'identitat.  
              Els seus restaurants, hotels, càterings i altres productes conformen un   
              ecosistema gastronòmic al seu voltant.  
              La marca Nandu Jubany es defineix per la passió, l'autenticitat i la connexió   
              amb la terra, elements que es transmeten a través de la imatge i l'estil   
              culinari.  
              A Formentera20 explicarà el secret del seu èxit.</p>
              `,
              en: `
              <p>Chef Nandu Jubany will be at Formentera20 and will share his   
              experience and how he has built a brand through passion, risk, and   
              creativity.  
              Nandu Jubany's brand identity is characterized by the authenticity,   
              passion, and energy that he conveys in both his cooking and his   
              projects. His hallmark is his personality, which brings his restaurants   
              and other projects together under a single culinary universe.  
              Nandu Jubany is the creative center of his brand, and his personality,   
              intensity, and passion are his hallmarks.  
              His restaurants, hotels, catering, and other products form a   
              gastronomic ecosystem around him.  
              The Nandu Jubany brand is defined by passion, authenticity, and a   
              connection to the land, elements that are conveyed through his image   
              and culinary style.  
              At Formentera20, he will explain the secret of his success.</p>
              `,
            },
            role: {
              es: `Chef`,
              ca: `Chef`,
              en: `Chef`,
            },
          }
        },
        {
          name: "Vimeo",
          props: {
            id: "1133193364",
          },
        },
        footer,
      ]
    }
  ],
}

export default data